module.exports = __webpack_public_path__ + "img/menu.a270243f.svg";